module.exports = __webpack_public_path__ + "img/ic_32_exercises_core.7491335d.svg";